import { ApiError } from './api';

export interface DisplayError {
  message: string;
  details?: string[];
}

/**
 * Normalises any thrown value into a French, user-facing message. API errors
 * carry the server's own `error.message` (and optional validation `details`),
 * which we surface verbatim — the server is authoritative.
 */
export function toDisplayError(error: unknown): DisplayError {
  if (error instanceof ApiError) {
    return { message: error.message, details: error.details };
  }
  if (error instanceof Error) {
    // Network / unexpected failures.
    return { message: 'Le serveur est injoignable. Veuillez réessayer.' };
  }
  return { message: 'Une erreur inattendue est survenue.' };
}
